export default __webpack_public_path__ + "static/media/icons8-umbrella-100.b0ba28d5.svg";